import { render } from "./JoeAndVi.vue?vue&type=template&id=0af49fe5"
import script from "./JoeAndVi.vue?vue&type=script&lang=js"
export * from "./JoeAndVi.vue?vue&type=script&lang=js"

import "./JoeAndVi.vue?vue&type=style&index=0&id=0af49fe5&lang=css"
script.render = render

export default script